import {EventBus} from "@/event-bus.js";

export function isValidLogin() {
	let hasToken = localStorage.token != undefined;
	let hasTokenExpire = localStorage.tokenExpire != undefined;
	let tokenExpired = hasTokenExpire && parseInt(localStorage.tokenExpire) <= Date.now();

	let validLogin = hasToken && hasTokenExpire && !tokenExpired;

	if (!validLogin) {
		console.warn("isValidLogin", {hasToken, hasTokenExpire, tokenExpired});
	}
	return validLogin;
}

let timeoutId = null;

EventBus.$on("USER_LOGOFF", () => {
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
});

export function isLoginPage() {
	let isLoginPage = window.location.hash.indexOf("#/login") == 0 || (window.location.hash.indexOf("#/token") == 0);
	const log = `login-status#isLoginPage URL (${window.location.hash}) ${isLoginPage ? "is" : "is not"} login page.`;
	console.info(log);
	return isLoginPage;
}

function checkIfNeedToLogoutByUrl() {
	if (isLoginPage()) {
		console.info("login-status#checkIfNeedToLogoutByUrl", "this is login page, doing emit");
		EventBus.$emit("USER_LOGOFF");
	}
}

EventBus.$on("USER_LOGIN", () => {
	checkLogin(true);
});

export function checkLogin(doTimeout = false) {
	if (!isValidLogin()) {
		if (isLoginPage()) {
			console.info("login-status#checkLogin", "already in login page");
		}
		else {
			console.info("login-status#checkLogin", "redirecting to login page");
			location.href = "#/login";
		}
	}
	else {
		if (doTimeout) {
			let seconds = localStorage.tokenExpire - Date.now();
			console.info(`status#checkLogin check again in ${seconds} seconds`);
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
			timeoutId = setTimeout(checkLogin, seconds * 1000);
		}
		else {
			console.info("status#checkLogin should not check again later");
		}
	}
	return true;
}

function onStartLSM() {
	checkIfNeedToLogoutByUrl();
	window.addEventListener("hashchange", checkIfNeedToLogoutByUrl);
}

EventBus.$once("LSM::start", onStartLSM);
